export * from "-!../../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help.vue?vue&type=template&id=0b786f28&"


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/help.vue?vue&type=template&id=0b786f28&
// module id = 513
// module chunks = 30